var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 0.099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 20,
    height: 20,
    transform: "translate(0 -0.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(1.551 3.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1702.9,789.778q-1.965,0-3.93,0c-.511,0-.7-.2-.7-.7q0-3.125,0-6.25c0-.521.2-.723.738-.723q3.9,0,7.8,0c.479,0,.686.195.687.66q0,3.166,0,6.332c0,.489-.192.673-.695.673q-1.951,0-3.9,0Z",
    transform: "translate(-1698.251 -782.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1732.323,800.377h-6.445a2.354,2.354,0,0,0-.517-1.766h4.838c.008-.114.02-.194.02-.275q0-2.913,0-5.826c0-.457.2-.667.662-.669.966-.005,1.933,0,2.9,0a1.039,1.039,0,0,1,1.009.651c.379.775.774,1.543,1.155,2.317a1.552,1.552,0,0,0,.814.764.835.835,0,0,1,.553.822c0,1.124.007,2.249,0,3.373,0,.438-.274.652-.727.588a2.191,2.191,0,0,0-.737-1.942,2.032,2.032,0,0,0-1.489-.514A2.174,2.174,0,0,0,1732.323,800.377Zm.91-4.982c.445,0,.89.005,1.336,0,.374-.006.5-.179.358-.519-.268-.661-.556-1.314-.817-1.977a.487.487,0,0,0-.483-.345c-.686-.008-1.373,0-2.059,0-.191,0-.278.089-.275.293.009.649,0,1.3,0,1.948a.538.538,0,0,0,.6.6C1732.342,795.4,1732.788,795.4,1733.233,795.395Z",
    transform: "translate(-1720.262 -790.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1767.335,827.414a1.522,1.522,0,1,1-1.539,1.511A1.512,1.512,0,0,1,1767.335,827.414Z",
    transform: "translate(-1753.116 -818.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1711.734,828.933a1.514,1.514,0,1,1-1.477-1.52A1.5,1.5,0,0,1,1711.734,828.933Z",
    transform: "translate(-1706.729 -818.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1699.53,829.7c-.28,0-.528,0-.777,0a.441.441,0,0,1-.108-.024c-.4-.111-.546-.488-.454-1.2a.6.6,0,0,1,.65-.553c.38,0,.76,0,1.2,0A2.367,2.367,0,0,0,1699.53,829.7Z",
    transform: "translate(-1698.165 -819.328)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDelivery);
export default __webpack_public_path__ + "static/media/white_delivery.8e6de32703bef2b36ce17277a3fc626a.svg";
export { ForwardRef as ReactComponent };